const ECommAppCards = () => {
    const eComCard = [
        {
            title: "PunkIPA",
            subTitle: "Front-End App",
            text: "Part of the Bootcamp, the Punk IPA app was developed by myself and fellow student Stefan.  Using an API to get the product information, a price generator NPM module we put together the PunkIPA App.  This is a front end only version, using local storage.",
            image: "./images/punkIPAApp.png",
            imageAlt: "PunkIPA App",
            linkUrl: "https://punkipa.netlify.app/",
            linkText: "PunkIPA App"
        },
        {
            title: "PunkIPA",
            subTitle: "Full Stack GitHub Repo",
            text: "GitHub Repository for the full stack version, using MondoDB for the backend database.",
            image: "./images/Github_logo.png",
            imageAlt: "PunkIPA GitHub Repo",
            linkUrl: "https://github.com/stefanthomasjones/PunkSite",
            linkText: "PunkSite Code"
        },
        {
            title: "PunkIPA",
            subTitle: "Front-End Repo",
            text: "GitHub Repository for the front-end demo",
            image: "./images/Github_logo.png",
            imageAlt: "PunkIPA FE GitHub Repo",
            linkUrl: "https://github.com/DataSpot42/punk-local-app",
            linkText: "PunkSite FE Code"
        }


    ]
    return (eComCard)
}
export default ECommAppCards